import { Schemas } from '~/api/gen'
import { Chip } from '~/components/elements/Chip'
import { TitledChipList } from '~/components/modules/TitledChipList'
import { buildUrl } from '~/features/shared/search/coordinate/builder/buildUrl'

type Props = {
  nickName: string
  frequentlyUsedCoordinateItems: Schemas.frequently_used_coordinate_item[]
}

export const FrequentlyUsedCoordinateItems: React.FC<Props> = ({
  nickName,
  frequentlyUsedCoordinateItems,
}) => {
  return (
    <TitledChipList title={`${nickName}がよく着用するアイテム`}>
      {frequentlyUsedCoordinateItems.map((item) => {
        if (!item.brand_keyword) return
        if (!item.brand_keyword || !item.item_category_keyword) return

        const chipContent = item.item_child_category_keyword
          ? `${item.view_brand}の${item.view_item_child_category}`
          : `${item.view_brand}の${item.view_item_category}`

        return (
          <li key={chipContent}>
            <Chip
              href={buildUrl({
                // HACK：本来はIDが必要だが、URLに使われないので0を入れています
                snapItems: [
                  {
                    brand: {
                      id: 0,
                      key: item.brand_keyword,
                      name: item.view_brand,
                    },
                    category: {
                      id: 0,
                      key: item.item_category_keyword,
                      name: item.view_item_category,
                      child:
                        item.item_child_category_keyword &&
                        item.view_item_child_category
                          ? {
                              id: 0,
                              key: item.item_child_category_keyword,
                              name: item.view_item_child_category,
                            }
                          : undefined,
                    },
                  },
                ],
              })}
            >
              <span className="before:mr-[1px]">{chipContent}</span>
            </Chip>
          </li>
        )
      })}
    </TitledChipList>
  )
}
